import React from 'react'
import PropTypes from 'prop-types'
import { SpinningMask, Line } from 'src/components'
import { getColor } from 'src/styles'
import { mergeProps } from 'src/util'
import { Rows } from '../../layout'
import styles from './CardValue.scss'

/**
 * A simple title & content card-style component.
 */
const CardValue = ({ title, row, color, loading, children, ...domProps }) => {
  return (
    <Line
      vertical={!row}
      layout="auto 1"
      align="center"
      {...mergeProps()(
        {
          className: styles.card,
          style: { backgroundColor: color && `${getColor(color, 33)}` },
        },
        domProps
      )}
    >
      {!!title && (
        <div className={styles.title} style={{ color: getColor(color) }}>
          {title}
        </div>
      )}
      {children && (
        <SpinningMask loading={loading} size="xs">
          <Rows align="center" justify="center" className={styles.content}>
            {children}
          </Rows>
        </SpinningMask>
      )}
    </Line>
  )
}

CardValue.defaultProps = {
  color: null,
}

CardValue.propTypes = {
  /**
   * The title to display.
   */
  title: PropTypes.node,
  /**
   * Whether the display direction should be in row.
   */
  row: PropTypes.bool,
  /**
   * The color of the card.
   */
  color: PropTypes.string,
  /**
   * Whether the card is loading or not.
   */
  loading: PropTypes.bool,
  /**
   * The content of the card.
   */
  children: PropTypes.node,
}

export default CardValue
